import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=0379e88a"
import script from "../../services/student/payment-method.js?vue&type=script&lang=js&external"
export * from "../../services/student/payment-method.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports